import { algoliaIndexNameFR, algoliaIndexNamePT } from '@/lib/env';
const isDev = process.env.NODE_ENV === 'development';
// to test locales, run:
// pnpm run dev & PORT=3001 pnpm run dev & PORT=3002 pnpm run dev

export const i18n = {
  defaultLocale: 'fr-FR',
  locales: [
    {
      id: 'fr-FR',
      icon: '🇫🇷',
      title: 'Français ',
      country: 'France',
      domain: isDev ? 'localhost:3000' : 'magic-stickers.com',
      algoliaIndexName: algoliaIndexNameFR,
      default: true
    },
    {
      id: 'fr-BE',
      icon: '🇧🇪',
      title: 'Français ',
      country: 'Belgique',
      domain: isDev ? 'localhost:3002' : 'magic-stickers.be',
      algoliaIndexName: algoliaIndexNameFR
    },
    {
      id: 'pt-PT',
      icon: '🇵🇹',
      title: 'Portugais ',
      country: 'Portugal',
      domain: isDev ? 'localhost:3001' : 'magic-stickers.pt',
      algoliaIndexName: algoliaIndexNamePT
    }
  ]
} as const;

export type Locale = (typeof i18n)['locales'][number];
